import { render, staticRenderFns } from "./TrainingPage.vue?vue&type=template&id=6173fc4e&scoped=true"
import script from "./TrainingPage.vue?vue&type=script&lang=js"
export * from "./TrainingPage.vue?vue&type=script&lang=js"
import style0 from "./TrainingPage.vue?vue&type=style&index=0&id=6173fc4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6173fc4e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCol,VRow,VSelect})
